// global
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Search } from 'semantic-ui-react';
// stylesheet
import styles from './Search.module.scss';

function CustomSearch(props) {
  const initialState = {
    searchQuery: ''
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    //
    return () => {
      setState({ searchQuery: '' });
    };
  }, []);

  const handleSearchChange = (_e, { value }) => {
    props.handleSearchChange(value);
    setState({ searchQuery: value });
  };

  const handleResultSelect = (_e, data) => {
    const { result } = data;
    const { title, id } = result;

    props.handleResultSelect({ id, title });

    const value = clearSearch ? '' : title;

    setState({ searchQuery: value });
  };

  const { searchQuery } = state;
  const { isForm, noResultsMessage, results, clearSearch, styleName, ...rest } = props;
  const CustomSearch = isForm ? Form.Search : Search;

  return (
    <CustomSearch
      {...rest}
      results={results}
      value={searchQuery}
      onSearchChange={handleSearchChange}
      onResultSelect={handleResultSelect}
      noResultsMessage={noResultsMessage}
      className={styles[styleName]}
    />
  );
}

CustomSearch.defaultProps = {
  isForm: false,
  styleName: 'styleDefaultSearch',
  placeholder: 'Pesquisar...',
  noResultsMessage: 'Termo não encontrado.'
};

CustomSearch.propTypes = {
  isForm: PropTypes.bool,
  results: PropTypes.array,
  clearSearch: PropTypes.bool,
  handleSearchChange: PropTypes.func,
  handleResultSelect: PropTypes.func,
  noResultsMessage: PropTypes.string,
  styleName: PropTypes.oneOf(['styleDefaultSearch', 'newStyleSearch', 'searchReport'])
};

export default CustomSearch;
